import { useAppSelector } from 'store';
import { Role, Roles, BackOfficeRoles } from 'types';
import { selectAuthUserRole } from 'store/slices/auth';

const employeeCommissionInfoRoles = [
  Roles.COMPANY_OWNER,
  BackOfficeRoles.ADMIN_REP,
];

export const useHideEmployeeCommissions = () => {
  const authUserRole = useAppSelector(selectAuthUserRole);

  const hideEmployeeCommissions = !employeeCommissionInfoRoles.includes(
    authUserRole as Role
  );

  return hideEmployeeCommissions;
};
